export const table = {
  root: {
    '& th': {
      textTransform: 'uppercase',
    },
  },
};
